export const skillData = {
    frontend : [
        {
            name : "HTML / CSS",
            level : 4,
            description : "I am knowledgeable in HTML and CSS"
        },
        {
            name : "Vanilla JavaScript",
            level : 4,
            description : "I am knowledgeable in Vanilla JavaScript"
        },
        {
            name : "React",
            level : 3,
            description : "I am knowledgeable in Java"
        },
    ],
    backend : [
        {
            name : "Java",
            level : 3,
            description : "I am knowledgeable in Java"
        },
        {
            name : "C#",
            level : 2,
            description : "I am knowledgeable in C#"
        },
        {
            name : "Python",
            level : 2,
            description : "I am knowledgeable in Python"
        },
        {
            name : "SQL",
            level : 2,
            description : "I am knowledgeable in SQL"
        },
        {
            name : "MongoDB",
            level : 2,
            description : "I am knowledgeable in MongoDB"
        },
    ],
    other : [
        {
            name : "Git",
            level : 2,
            description : "Currently learning Git"
        },
        {
            name : "Scrum Methodology",
            level : 2,
            description : "Just learning how to practice Agile scrum methodology"
        },
    ]
}